import React, { useState } from 'react'
import { observer } from 'mobx-react'
import Flex from 'components/UI/Flex/Flex'
import slotsScheduleSettingsStore from 'Stores/slotsScheduleSettingsStore'
import styles from './TimeTabs.module.scss'
import ModalWrapper from 'components/UI/ModalWrapper/ModalWrapper'
import InputWithControls from 'components/UI/InputWithControls/InputWithControls'
import Button from 'components/UI/Button/Button'
import Hr from 'components/UI/Hr/Hr'
import SelectCustom from '../../../../../ContentBox/Global/Select/SelectCustom'
import FormField from '../../../../../UI/AsideModal/Form/FormField'
import FormLabel from '../../../../../UI/AsideModal/Form/FormLabel'

const selectors = [
  { id: 1, value: 15, text: '15 мин' },
  { id: 2, value: 30, text: '30 мин' },
  { id: 3, value: 45, text: '45 мин' },
  { id: 4, value: 60, text: '60 мин' },
  { id: 5, value: 90, text: '90 мин' },
  { id: 6, value: 'custom', text: 'Свое' },
]

const findSelectedValue = (id) => selectors.find((item) => item.id === id).value
const isCustomDuration = (duration) =>
  selectors.every(({ value }) => value !== duration)

function TimeTabs() {
  const { duration, setTime } = slotsScheduleSettingsStore
  const [isModalShown, setIsModalShown] = useState(false)
  const [customTime, setCustomTime] = useState(duration)

  const handleSelectChange = (option) => {
    const id = +option.id
    if (id === 6) {
      setIsModalShown(true)
    } else {
      setTime(findSelectedValue(id), 'duration')
    }
  }

  const handleModalSubmit = () => {
    setTime(+customTime, 'duration')
    setIsModalShown(false)
  }

  return (
    <>
      <FormField>
        <FormLabel>Длительность:</FormLabel>
        <SelectCustom
          options={selectors.map(({ id, text }) => ({
            id: id.toString(),
            label:
              id === 6 && isCustomDuration(duration) ? `${duration} мин` : text,
          }))}
          value={
            selectors.find(({ value }) => value === duration) || {
              id: '6',
              label: `${duration} мин`,
            }
          }
          onChange={handleSelectChange}
          placeholder='Выберите длительность'
        />
      </FormField>

      {isModalShown && (
        <ModalWrapper
          title='Своя длительность'
          onClose={() => setIsModalShown(false)}
          classes={styles.modal}
        >
          <InputWithControls
            onChange={(value) => setCustomTime(value)}
            value={customTime}
            type='мин.'
            justify='center'
            step={15}
            max={480}
          />
          <Hr withTopMargin={false} />
          <Flex>
            <Button variant='white' onClick={() => setIsModalShown(false)}>
              Отменить
            </Button>
            <Button onClick={handleModalSubmit}>Добавить</Button>
          </Flex>
        </ModalWrapper>
      )}
    </>
  )
}

export default observer(TimeTabs)
